const plus = (
  <>
    <path d="M2 8L14 8" stroke="currentColor" strokeLinecap="round" />
    <path d="M8 2V14" stroke="currentColor" strokeLinecap="round" />
  </>
);
export default plus;
